module.exports = __webpack_public_path__ + "media/30.d10a42e5.mp3";